<template>
    <v-btn
        variant="outlined"
        :class="{ 'selected': modelValue, rounded }"
    >
        <div
            class="color-image-swatch w-100 h-100"
            :class="{
                'rounded-circle': innerCircle && !rounded
            }"
            :style="{
                backgroundImage: `url(${image})`
            }"
        ></div>
    </v-btn>
</template>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            modelValue?: Nilish<boolean>;
            image: string;
            rounded?: boolean;
            innerCircle?: boolean;
        }>(),
        {
            rounded: true,
            innerCircle: false
        }
    );
</script>

<style lang="scss"></style>
